/** @jsxImportSource theme-ui */

import React, { FC, useState, useEffect } from "react"
import { useRouter } from "next/router"
import { NextSeo } from "next-seo"
import { LoadingDots } from "@components/ui"
import builderConfig from "@config/builder"
import {
  ProductCardsWithFullImage,
  ProductCardsWithFullImageProps,
} from "../ProductCards/WithFullImage"
import { getProductsByCollection } from "@lib/swell/storefront-data-hooks/src/api/operations-swell"

interface Props {
  className?: string
  children?: any
  collection: string | any
  category: any
  productGridOptions: ProductCardsWithFullImageProps
  renderSeo?: boolean
}

const CollectionPreview: FC<Props> = ({
  collection: initialCollection,
  productGridOptions,
  renderSeo,
  category,
}) => {
  const [collection, setCollection] = useState(initialCollection)
  const [loading, setLoading] = useState(false)
  const router = useRouter()
  const { page, handle } = router.query

  useEffect(() => setCollection(initialCollection), [initialCollection])
  useEffect(() => {
    const fetchCollection = async () => {
      setLoading(true)
      const result = await getProductsByCollection(builderConfig, {
        // @ts-ignore
        handle: handle,
        productsQuery: {
          limit: 15,
          // @ts-ignore
          page: page,
        },
      })

      setCollection(result)
      setLoading(false)
    }

    fetchCollection()
  }, [page, handle])

  if (!collection || typeof collection === "string" || loading) {
    return <LoadingDots />
  }

  const { products } = collection
  const { title, description, images } = collection.category
  return (
    <div sx={{ display: "flex", flexDirection: "column" }} key={collection.id}>
      {renderSeo && (
        <NextSeo
          title={collection.title}
          description={collection.description}
          openGraph={{
            type: "website",
            title,
            description,
          }}
        />
      )}
      <div sx={{ display: "flex", flexDirection: "column" }}>
        <span sx={{ mt: 0, mb: 2 }}>
          <h1>{collection.title}</h1>
        </span>
        <div dangerouslySetInnerHTML={{ __html: collection.description! }} />
      </div>
      <div>
        <ProductCardsWithFullImage
          {...productGridOptions}
          products={products}
          collection={collection}
          limit={15}
        />
      </div>
    </div>
  )
}

export default CollectionPreview
